<div class="c">
  <div class="container mt-5 text-center">
    <div class="alert alert-danger">
      <h2>You don't have the permissions to view user mgmt application</h2>
    <h5>Please contact System Administrator to get access</h5>
    </div>
  </div>
</div>